module.exports = __webpack_public_path__ + "static/media/registration_stoplight.73bb99fe.svg";